import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
// import { NgxChartsModule } from '@swimlane/ngx-charts';

import { FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TaskOverviewChartWidgetComponent } from './task-overview-chart-widget.component';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';

@NgModule({
    declarations: [
        TaskOverviewChartWidgetComponent,
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        PhoenixDirectivesModule,

        FuseWidgetModule,
        FuseSharedModule,
     ],
    exports: [
        TaskOverviewChartWidgetComponent,
    ],
    providers: [],
})
export class ChartWidgetsModule {}
